import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Settings, AppSettings } from 'src/app/app.settings';
import { BroadcastMessageService } from 'src/services/broadcastMessageService';
import { PageContentService } from '../../../../services/pagecontent.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'app-toolbar1',
    templateUrl: './toolbar1.component.html',
    styleUrls: ['./toolbar1.component.scss']
})
export class Toolbar1Component implements OnInit {

    public settings: Settings;
    public isToolbarvisible: boolean;
    projectList: [];
    public langId: number;
    subscription: Subscription;

    @Output() onMenuIconClick: EventEmitter<any> = new EventEmitter<any>();
    constructor(public appService: AppService,
        private broadcastMessageService: BroadcastMessageService,
        public appSettings: AppSettings, public pageservice: PageContentService) {
        this.settings = this.appSettings.settings;
        //this.isToolbarvisible == this.settings.istoolbarvisible;
        this.subscription = this.broadcastMessageService.getMessage().subscribe(message => {
            this.langId = +message.text;
            
        });
    }

    ngOnInit() {
        this.getAdvertisement();
    }


    getAdvertisement() {
        this.langId = this.settings.langId;
        this.pageservice.getPublicationList(this.langId).subscribe(result => {
            if (result != null && result != undefined) {
                this.projectList = result.filter(item => item.title === 'Documents').reverse();
                console.log('toolbar' , this.projectList)
            }
        });
    }

    public sidenavToggle() {
        this.onMenuIconClick.emit();
    }

    downloadInternalAuditpdf () {
        const link = document.createElement('a');
        link.href = 'assets/pdf/STAUTORY&INTERNAL-AUDIT-TANSACS.pdf';
        link.download = 'STAUTORY & INTERNAL AUDIT-TANSACS.pdf';
        link.target = '_blank';
        link.click();
    }

    downloadChallengesInPartnerManagementPdf () {
        const link = document.createElement('a');
        link.href = 'assets/pdf/SI-Division.pdf';
        link.download = 'SI-Division.pdf';
        link.target = '_blank';
        link.click();
    }

    downloadEOIpdf () {
        const link = document.createElement('a');
        link.href = 'assets/pdf/EOI-SelectionofNGO(TI-Project-6&LWS).pdf';
        link.download = 'EOI - Selection of NGO (TI Project - 6 & LWS Proje_250818_155240).pdf';
        link.target = '_blank';
        link.click();
    }

    downloadIECCampainpdf () {
        const link = document.createElement('a');
        link.href = 'assets/pdf/ENTRY-FORMS.pdf';
        link.download = 'ENTRY FORMS.pdf';
        link.target = '_blank';
        link.click();
    }

    downloadTenderNotice2026 () {
        const link = document.createElement('a');
        link.href = 'assets/pdf/Tendernotice.pdf';
        link.download = 'TendetNotice.pdf';
        link.target = '_blank';
        link.click();
    }

    downloadNominationpdf () {
        const link = document.createElement('a');
        link.href = 'assets/pdf/APPLICATION_FOR_NOMINATION-EC-&-GB.pdf';
        link.download = 'APPLICATION FOR NOMINATION -EC & GB.pdf';
        link.target = '_blank';
        link.click();
    }
    districtLevelContractPost () {
        window.open(
            'assets/pdf/CST-DIVISION-VACANT-POST.pdf',
            '_blank'
        );
    }
    implementing5AdditionalCare () {
        window.open(
            'assets/pdf/EOI&NEWSPepers___FINAL-OCT14,2026(1)_0873.pdf',
            '_blank'
        );
    }
    downloadTIAdvertisementPdf () {
        const files = [
            { href: 'assets/pdf/EOI-Selection-of-NGOs.pdf', download: 'EOI-Selection-of-NGOs.pdf.pdf' }
        ];
        files.forEach((file, index) => {
            setTimeout(() => {
                const link = document.createElement('a');
                link.href = file.href;
                link.download = file.download;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }, index * 100);
        });
    }
}